import React from "react";
import "../../../css/View/SummaryPets.css";

const SummaryPets = ({ registrations }) => {
  const people = (registrations || []).flatMap((r) => {
    const activeParticipants = (r.participants || []).filter((p) => p.status !== 4 && p.status !== 5);
    const primary = activeParticipants.find((p) => p.isPrimary);
    if (!primary) return [];
    return [{ ...primary, reservationCode: r.reservationCode, participantCount: !r.createdAt ? (r.pax || 0) : activeParticipants.length, reservationStatus: r.status, hasPet: r.additionalInfo?.hasPet, petInfo: r.additionalInfo?.petInfo }];
  });

  const withPets = people.filter((p) => p.hasPet === true);
  const renderValue = (v) => (v && String(v).trim() ? v : "-");

  const renderTable = (data) => (
    <div className="table-scroll-container">
      <table className="summary-pets-table">
        <thead><tr><th>Rezerwacja</th><th>Informacje o zwierzęciu</th></tr></thead>
        <tbody>{data.map((p, idx) => (
          <tr key={`${p.reservationCode}-${idx}`}>
            <td><div className="summary-reservation-inline"><span className={`reg-code status-${p.reservationStatus}`}>{p.reservationCode}</span><span className="participant-name">{p.preferredName}</span><span className="reservation-count">(x {p.participantCount})</span></div></td>
            <td>{renderValue(p.petInfo)}</td>
          </tr>
        ))}</tbody>
      </table>
    </div>
  );

  return <div className="summary-pets-container"><h3>Ze zwierzętami</h3>{renderTable(withPets)}</div>;
};

export default SummaryPets;
